import { toast } from 'sonner';
import { heldReasonLabel, STATUS_STYLES } from './OutreachMessageStatusPill';

const ON_ITS_WAY = new Set(['queued', 'sending', 'sent']);

/** The label the thread's MessageTag shows for this status; a held message adds its reason, as the row pill does. */
export function sendStatusLabel(status: string, heldReason?: string): string {
  const label = (STATUS_STYLES as Record<string, { label: string } | undefined>)[status]?.label ?? status;
  return status === 'held' && heldReason ? `${label} · ${heldReasonLabel(heldReason)}` : label;
}

/** A human send's toast states the status the send API returned, never a blanket "sending now". */
export function toastSendStatus(what: string, result: { status: string; heldReason?: string }) {
  const text = `${what}: ${sendStatusLabel(result.status, result.heldReason)}`;
  if (ON_ITS_WAY.has(result.status)) toast.success(text);
  else toast.warning(text);
}
